/** @type {readonly number[]} */
export const LEVERAGE_STEPS = [
  1, 2, 5, 10, 20, 25, 50, 75, 100, 125, 150, 200, 250, 300, 500, 750, 1000,
];

export const LEVERAGE_MIN = LEVERAGE_STEPS[0];
export const LEVERAGE_MAX = LEVERAGE_STEPS[LEVERAGE_STEPS.length - 1];
export const LEVERAGE_DEFAULT = 10;

export const LONG_COLOR = "#2FA766";
export const SHORT_COLOR = "#E2464A";
export const MUTED_COLOR = "#6E7784";

export const MIN_ORDER_COST_USDT = 5;
